import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_input.scss'

import { Props, TextAreaAttributes } from '../utils/types'

export namespace TextAreaResizeNS {
  export const both = 'both'
  export const horizontal = 'horizontal'
  export const none = 'none'
  export const vertical = 'vertical'
}

export namespace TextAreaVariantNS {
  export const error = 'error'
  export const none = ''
}

type TextAreaResize =
  | typeof TextAreaResizeNS.both
  | typeof TextAreaResizeNS.horizontal
  | typeof TextAreaResizeNS.none
  | typeof TextAreaResizeNS.vertical

type TextAreaVariant =
  | typeof TextAreaVariantNS.error
  | typeof TextAreaVariantNS.none

interface TextAreaProps extends Props {
  variant?: TextAreaVariant
  resize?: TextAreaResize
  textareaRef?: React.Ref<HTMLTextAreaElement>
}

const cx = bind(styles)

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  TextAreaAttributes & TextAreaProps
>(
  (
    {
      className,
      resize = TextAreaResizeNS.both,
      style = {},
      variant,
      textareaRef,
      ...props
    },
    ref
  ) => (
    <textarea
      ref={ref || textareaRef}
      style={{ ...style, resize }}
      className={cx(
        'core-textarea',
        {
          [`core-textarea--${variant}`]: variant,
        },
        className
      )}
      {...props}
    />
  )
)

export default TextArea
